import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlipHorizontal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_9190_33263)",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M15.3277 2.68262L10.3708 7.71531C10.2169 7.87151 10.2169 8.12481 10.3707 8.28101L15.3276 13.3169C15.5757 13.5689 16 13.3905 16 13.0341V2.96549C16 2.60917 15.5758 2.43069 15.3277 2.68262Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M-3.76701e-05 14.6033L-3.76701e-05 1.39636L6.50195 7.99839L-3.76701e-05 14.6033ZM1.4769 5.01744L1.4769 10.9823L4.41347 7.99839L1.4769 5.01744Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M8.61549 13L7.63086 13V16L8.61549 16V13Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M8.61549 8.99988L7.63086 8.99988V10.9999L8.61549 10.9999V8.99988Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M8.61549 5.00012L7.63086 5.00012V7.00012L8.61549 7.00012V5.00012Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M8.61549 7.42422e-07L7.63086 6.99382e-07V2.99999L8.61549 2.99999V7.42422e-07Z" })
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_9190_33263",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "translate(16) rotate(90)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFlipHorizontal);
export default ForwardRef;
